import React from 'react';
import { Iframe } from '../../UI/Media';
import { TextWithLine } from '../Banners/BannerText/bannerText';

export const CollectionYoutube = ({ label, iframe }) => (
  <div className='w-full py-12'>
    <TextWithLine
      label={{
        ...label,
        size: '5xl',
        color: { classname: 'gray-800' },
      }}
    />
    <div className='lg:px-20'>
      <Iframe {...iframe} />
    </div>
  </div>
);
